import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./plugins/vuex";
import "./plugins/vuex-rest";
import "./plugins/v-hover";
import "./plugins/hooper";
import storeauth from "./store";
import "./plugins/vuex-rest-auth";
import "./plugins/simple-auth";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/main.scss";
import "./styles/ck-content.css";

import { server } from "./config";

Vue.config.productionTip = false;

Vue.mixin({
  data: () => ({
    server,
    files: server,
  }),
});

new Vue({
  router,
  storeauth,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
